import { render } from "./MemberApplicationTabBerkasPendukung.vue?vue&type=template&id=9b4f3550&scoped=true"
import script from "./MemberApplicationTabBerkasPendukung.vue?vue&type=script&lang=js"
export * from "./MemberApplicationTabBerkasPendukung.vue?vue&type=script&lang=js"

import "./MemberApplicationTabBerkasPendukung.vue?vue&type=style&index=0&id=9b4f3550&scoped=true&lang=css"

import exportComponent from "/Users/mymac/Documents/Digitala/Perki/newest-perki/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b4f3550"]])

export default __exports__